{
  "familyId": "MET-OPP-SAMENGESTELD",
  "questions": [
    {
      "id": "MET-OPP-SAMENGESTELD-001",
      "familyId": "MET-OPP-SAMENGESTELD",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_samengesteld",
      "questionType": "step_solver",
      "question": "Een L-vormige figuur bestaat uit twee rechthoeken: 6×4 cm en 3×2 cm. Wat is de totale oppervlakte?",
      "context": null,
      "options": [],
      "correctAnswer": "30",
      "data": {
        "steps": [
          {
            "prompt": "Bereken de oppervlakte van rechthoek 1 (6 x 4 cm)",
            "correctAnswer": "24",
            "acceptedAnswers": ["24", "24 cm2"],
            "hint": "Oppervlakte = lengte x breedte = 6 x 4"
          },
          {
            "prompt": "Bereken de oppervlakte van rechthoek 2 (3 x 2 cm)",
            "correctAnswer": "6",
            "acceptedAnswers": ["6", "6 cm2"],
            "hint": "Oppervlakte = lengte x breedte = 3 x 2"
          },
          {
            "prompt": "Wat is de totale oppervlakte? (tel beide delen op)",
            "correctAnswer": "30",
            "acceptedAnswers": ["30", "30 cm2"],
            "hint": "24 + 6 = ?"
          }
        ],
        "showStepsProgressively": true
      },
      "stimulusAids": [
        {
          "type": "compositeShape",
          "data": {
            "rectangles": [
              { "x": 0, "y": 0, "width": 6, "height": 4, "label": "6×4" },
              { "x": 6, "y": 2, "width": 3, "height": 2, "label": "3×2" }
            ],
            "unit": "cm",
            "showGrid": true,
            "label": "L-vormige figuur"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Samengestelde oppervlakte",
            "content": "Verdeel de figuur in twee rechthoeken. Bereken elke oppervlakte apart en tel ze op. Rechthoek 1: 6 × 4 = 24 cm². Rechthoek 2: 3 × 2 = 6 cm². Totaal: 24 + 6 = 30 cm²."
          }
        }
      ],
      "conceptId": "area_composite_addition",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Bij een samengestelde figuur verdeel je de vorm in bekende stukken. Hier zie je twee rechthoeken: 6 x 4 = 24 cm2 en 3 x 2 = 6 cm2. Tel de oppervlaktes op: 24 + 6 = 30 cm2.",
        "solutionSteps": [
          "Verdeel de L-vormige figuur in twee losse rechthoeken",
          "Bereken de oppervlakte van rechthoek 1: 6 x 4 = 24 cm2",
          "Bereken de oppervlakte van rechthoek 2: 3 x 2 = 6 cm2",
          "Tel beide oppervlaktes bij elkaar op: 24 + 6 = 30 cm2"
        ]
      }
    },
    {
      "id": "MET-OPP-SAMENGESTELD-002",
      "familyId": "MET-OPP-SAMENGESTELD",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een tuinier heeft een T-vormig bloembed. Het bovenste deel is 10×2 meter, het onderste deel is 3×4 meter. Wat is de totale oppervlakte?",
      "context": "Een tuinier ontwerpt een bloembed.",
      "options": ["20 m²", "12 m²", "32 m²", "40 m²"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "compositeShape",
          "data": {
            "rectangles": [
              { "x": 0, "y": 0, "width": 10, "height": 2, "label": "10×2" },
              { "x": 3.5, "y": 2, "width": 3, "height": 4, "label": "3×4" }
            ],
            "unit": "m",
            "showGrid": true,
            "label": "T-vormig bloembed"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "T-vorm verdelen",
            "content": "Verdeel de T-vorm in twee rechthoeken. Boven: 10 × 2 = 20 m². Onder: 3 × 4 = 12 m². Totaal: 20 + 12 = 32 m²."
          }
        }
      ],
      "conceptId": "area_composite_t_shape",
      "variantIndex": 2,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De tuinier verdeelt het T-vormige bloembed in twee rechthoeken. Bovenste deel: 10 × 2 = 20 m². Onderste deel: 3 × 4 = 12 m². Totale oppervlakte: 20 + 12 = 32 m². Bij een T-vorm kun je altijd de horizontale balk en de verticale poot apart berekenen. Check: 32 is meer dan elk deel apart ✓.",
        "solutionSteps": [
          "Herken de T-vorm: een brede balk bovenaan en een smalle poot onderaan",
          "Bereken de bovenste rechthoek: 10 × 2 = 20 m²",
          "Bereken de onderste rechthoek: 3 × 4 = 12 m²",
          "Tel op: 20 + 12 = 32 m²"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk alleen het bovenste deel berekend (10 x 2 = 20 m2). Vergeet het onderste deel niet: 3 x 4 = 12 m2. Totaal: 20 + 12 = 32 m2.",
          "1": "Je hebt waarschijnlijk alleen het onderste deel berekend (3 x 4 = 12 m2). Vergeet het bovenste deel niet: 10 x 2 = 20 m2. Totaal: 20 + 12 = 32 m2.",
          "2": "Goed! 20 + 12 = 32 m2.",
          "3": "Je hebt waarschijnlijk 10 x 4 = 40 berekend, alsof het een grote rechthoek is. Maar de figuur is T-vormig. Verdeel in twee delen: 10 x 2 = 20 en 3 x 4 = 12, totaal 32 m2."
        }
      }
    },
    {
      "id": "MET-OPP-SAMENGESTELD-003",
      "familyId": "MET-OPP-SAMENGESTELD",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een glazenier maakt een rechthoekig raam van 8×6 cm. In het midden zit een vierkant gat van 2×2 cm. Wat is de oppervlakte van het glas?",
      "context": "Een glazenier maakt een raam met een opening.",
      "options": ["48 cm²", "44 cm²", "4 cm²", "52 cm²"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "compositeShape",
          "data": {
            "rectangles": [
              { "x": 0, "y": 0, "width": 8, "height": 6, "label": "8×6" },
              { "x": 3, "y": 2, "width": 2, "height": 2, "label": "2×2 (gat)" }
            ],
            "unit": "cm",
            "showGrid": true,
            "label": "Raam met gat"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte met aftrekken",
            "content": "Bereken het grote geheel en trek het gat eraf. Rechthoek: 8 × 6 = 48 cm². Gat: 2 × 2 = 4 cm². Glas = 48 − 4 = 44 cm²."
          }
        }
      ],
      "conceptId": "area_composite_subtraction",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De glazenier berekent eerst de hele rechthoek: 8 × 6 = 48 cm². Dan trekt die het gat eraf: 2 × 2 = 4 cm². Het glas = 48 − 4 = 44 cm². Dit is de aftrekmethode: bereken het geheel en trek het ontbrekende stuk eraf. Check: 44 + 4 = 48 ✓.",
        "solutionSteps": [
          "Bereken de oppervlakte van de hele rechthoek: 8 × 6 = 48 cm²",
          "Bereken de oppervlakte van het gat: 2 × 2 = 4 cm²",
          "Trek het gat af: 48 − 4 = 44 cm²",
          "Check: 44 + 4 = 48 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk alleen de grote rechthoek berekend (8 x 6 = 48 cm2) zonder het gat eraf te trekken. Het gat is 2 x 2 = 4 cm2, dus het glas = 48 - 4 = 44 cm2. Onthoud: trek het gat eraf.",
          "1": "Goed! 48 - 4 = 44 cm2.",
          "2": "Je hebt waarschijnlijk alleen het gat berekend (2 x 2 = 4 cm2). Maar de vraag is naar het glas, niet het gat. Glas = hele rechthoek - gat = 48 - 4 = 44 cm2.",
          "3": "Je hebt waarschijnlijk het gat opgeteld in plaats van afgetrokken (48 + 4 = 52). Maar het gat zit erin, dus je trekt het eraf: 48 - 4 = 44 cm2. Onthoud: gat = aftrekken."
        }
      }
    },
    {
      "id": "MET-OPP-SAMENGESTELD-004",
      "familyId": "MET-OPP-SAMENGESTELD",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een zwembad heeft een U-vorm. Het bestaat uit drie rechthoeken: links 2×6 m, midden 6×2 m, rechts 2×6 m. Wat is de totale oppervlakte?",
      "context": "Een zwembad in U-vorm.",
      "options": ["24 m²", "72 m²", "48 m²", "36 m²"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "compositeShape",
          "data": {
            "rectangles": [
              { "x": 0, "y": 0, "width": 2, "height": 6, "label": "2×6" },
              { "x": 2, "y": 4, "width": 6, "height": 2, "label": "6×2" },
              { "x": 8, "y": 0, "width": 2, "height": 6, "label": "2×6" }
            ],
            "unit": "m",
            "showGrid": true,
            "label": "U-vormig zwembad"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "U-vorm in drie delen",
            "content": "Verdeel de U in drie rechthoeken. Links: 2 × 6 = 12 m². Midden: 6 × 2 = 12 m². Rechts: 2 × 6 = 12 m². Totaal: 12 + 12 + 12 = 36 m²."
          }
        }
      ],
      "conceptId": "area_composite_u_shape",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Het U-vormige zwembad bestaat uit drie rechthoeken. Links: 2 × 6 = 12 m². Midden (onderkant): 6 × 2 = 12 m². Rechts: 2 × 6 = 12 m². Totaal: 12 + 12 + 12 = 36 m². Bij een U-vorm verdeel je in twee staande delen en één liggend deel. Check: 36 is minder dan een volle rechthoek van 10 × 6 = 60 m² ✓.",
        "solutionSteps": [
          "Verdeel de U-vorm in drie rechthoeken: links, midden, rechts",
          "Links: 2 × 6 = 12 m²",
          "Midden: 6 × 2 = 12 m²",
          "Rechts: 2 × 6 = 12 m²",
          "Tel op: 12 + 12 + 12 = 36 m²"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk maar twee van de drie delen berekend (12 + 12 = 24 m2). Vergeet het derde deel niet! De U heeft drie rechthoeken: 12 + 12 + 12 = 36 m2.",
          "1": "Je hebt waarschijnlijk alle getallen vermenigvuldigd (2 x 6 x 6 x 2 = 144, of 6 x 6 x 2 = 72). Maar je moet elk deel apart berekenen en optellen: 12 + 12 + 12 = 36 m2.",
          "2": "Je hebt waarschijnlijk de buitenmaten gebruikt (10 x 6 = 60, of 8 x 6 = 48). Maar de U-vorm is niet volledig gevuld. Bereken de drie delen apart: 12 + 12 + 12 = 36 m2.",
          "3": "Goed! 12 + 12 + 12 = 36 m2."
        }
      }
    },
    {
      "id": "MET-OPP-SAMENGESTELD-005",
      "familyId": "MET-OPP-SAMENGESTELD",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een speelplaats is een grote rechthoek van 12×8 meter. In de hoek staat een vierkant schuurtje van 3×3 meter. Hoeveel vierkante meter speelruimte is er?",
      "context": "Een school meet de speelplaats op.",
      "options": ["87 m²", "96 m²", "9 m²", "105 m²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "compositeShape",
          "data": {
            "rectangles": [
              { "x": 0, "y": 0, "width": 12, "height": 8, "label": "12×8" },
              { "x": 0, "y": 0, "width": 3, "height": 3, "label": "3×3 (schuur)" }
            ],
            "unit": "m",
            "showGrid": true,
            "label": "Speelplaats met schuurtje"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekmethode",
            "content": "Bereken het geheel en trek het schuurtje eraf. Speelplaats: 12 × 8 = 96 m². Schuurtje: 3 × 3 = 9 m². Speelruimte: 96 − 9 = 87 m²."
          }
        }
      ],
      "conceptId": "area_composite_subtraction_context",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De school berekent eerst de hele speelplaats: 12 × 8 = 96 m². Dan trekt die het schuurtje eraf: 3 × 3 = 9 m². Speelruimte = 96 − 9 = 87 m². Dit is de aftrekmethode: bereken het geheel en trek het bezette stuk eraf. Check: 87 + 9 = 96 ✓.",
        "solutionSteps": [
          "Bereken de hele speelplaats: 12 × 8 = 96 m²",
          "Bereken het schuurtje: 3 × 3 = 9 m²",
          "Trek het schuurtje af: 96 − 9 = 87 m²",
          "Check: 87 + 9 = 96 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 96 − 9 = 87 m².",
          "1": "Je hebt waarschijnlijk alleen de hele speelplaats berekend (12 × 8 = 96 m²) zonder het schuurtje eraf te trekken. Het schuurtje neemt 3 × 3 = 9 m² in, dus speelruimte = 96 − 9 = 87 m².",
          "2": "Je hebt waarschijnlijk alleen het schuurtje berekend (3 × 3 = 9 m²). Maar de vraag is naar de speelruimte: hele plein − schuurtje = 96 − 9 = 87 m².",
          "3": "Je hebt waarschijnlijk het schuurtje opgeteld (96 + 9 = 105). Maar het schuurtje neemt ruimte weg, dus je trekt het eraf: 96 − 9 = 87 m². Onthoud: bezet stuk = aftrekken."
        }
      }
    }
  ]
}